<template>
    <div>
        <p class="sub-heding-text text-zinc-50">Scan Activity</p>
    </div>
    <div class="flex flex-col gap-1">
        <table>
            <tbody>
                <tr>
                    <td><p class="sub-heding-text text-zinc-400 text-right width-text mb-1 mr-2">1h:</p></td>
                    <td>
                        <div class="flex justify-start items-center gap-1">
                            <div class="gradiant-blue rounded-full" style="width: 25%"></div>
                            <p class="sub-heding-text text-zinc-50">1,248</p>
                            <div class="flex flex-row items-center text-success font-semibold gap-1 status-text">
                                <up-arrow-svg />
                                12%
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><p class="sub-heding-text text-zinc-400 text-right width-text mb-1 mr-2">24h:</p></td>
                    <td>
                        <div class="flex justify-start items-center gap-1">
                            <div class="gradiant-blue rounded-full" style="width: 40%"></div>
                            <p class="sub-heding-text text-zinc-50">28,742</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><p class="sub-heding-text text-zinc-400 text-right width-text mb-1 mr-2">7d:</p></td>
                    <td>
                        <div class="flex justify-start items-center gap-1">
                            <div class="gradiant-blue rounded-full" style="width: 60%"></div>
                            <p class="sub-heding-text text-zinc-50">201,194</p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td><p class="sub-heding-text text-zinc-400 text-right width-text mb-1 mr-2">30d:</p></td>
                    <td>
                        <div class="flex justify-start items-center gap-1">
                            <div class="gradiant-blue rounded-full" style="width: 90%"></div>
                            <p class="sub-heding-text text-zinc-50">861,330</p>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup lang="ts">
    import UpArrowSvg from '~/components/main/soc/common_svg/UpArrowSvg.vue';
</script>
